import { createFlowPageIds } from 'src/app/shared/constants/pageUid';

export const isPreviousStep = (stepPageId: string, currentPageId: string) =>
  createFlowPageIds.indexOf(stepPageId) <
  createFlowPageIds.indexOf(currentPageId);

export const isLaterStep = (stepPageId: string, currentPageId: string) =>
  createFlowPageIds.indexOf(stepPageId) >
  createFlowPageIds.indexOf(currentPageId);
